<template>
    <div class="form-group" dir="ltr">
        <validation-item :label="label" :name="validationFieldName" :rules="rules" :vid="vid">
            <template>
                <range-slider :marks="marks" :data="data" @change="handleInputChange" :min="min" :max="max" :value="value">
                </range-slider>
                <input hidden :value="inputValue">
            </template>
        </validation-item>
    </div>
</template>

<script>
import ValidationItem from "./ValidationItem";
// import RangeSlider from "vue-range-component";
// import 'vue-range-component/dist/vue-range-slider.css'
import RangeSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
    name: "ValidationRangeSlider",
    components: {ValidationItem, RangeSlider},
    props: {
        label: {
            type: String,
            default: ''
        },
        validationFieldName: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Object, Array],
            default: ''
        },
        vid: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number, Array, Object],
            default: ''
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 0
        },
        data: {
            type: Array,
            default() {
                return undefined
            }
        },
        marks: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerValue: this.multiple ? [] : ''
        }
    },
    watch: {
        value(value) {
            this.innerValue = value
        },
        innerValue(newValue) {
            this.$emit('input', newValue)
        }
    },
    computed: {
        inputValue() {
            if (typeof this.value === 'object') {
                if (this.value.length > 0) {
                    return 'sdsd'
                } else {
                    return ''
                }
            } else {
                return this.value
            }
        }
    },
    mounted() {
        if (this.value !== '' || this.value.length > 0) this.innerValue = this.value
    },
    methods: {
        handleInputChange(value) {
            console.log(value)
            this.$emit('input', value)
        },
    }
}
</script>

<style scoped>

</style>
